import type { IconAsset } from '../Icon.types';

const code = (
  <g>
    <path
      d='M394.535,1488.228v9.562h13v-9.562Zm6.5,5.929-5.513-4.069.532-.721,4.987,3.681,5.11-3.684.524.727Z'
      data-name='Path 5780'
      fill='currentColor'
      id='Path_5780'
      transform='translate(-393.035 -1485.01)'
    />
    <rect
      data-name='Rectangle 24919'
      fill='none'
      height='16'
      id='Rectangle_24919'
      width='16'
    />
  </g>
);

export const mail: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
